import { createContext } from "react";

export const CombosContext = createContext()